import * as React from 'react'
import { ReactElement } from 'react'
import { LineItemProps } from './LineItem'
import { FixedPriceListItemDto } from '../../../../../config/registrationConfig'
import { Stack, Text } from '@fluentui/react'
import { Badge } from '@fluentui/react-components'
import useVatType from '../../../../../hooks/useVatType'
import FormattedDateBadge from '../../../../Date/FormattedDateBadge'

export default function FixedPriceLineItem({ entity }: LineItemProps<FixedPriceListItemDto>): ReactElement {
    const { vatTypeName } = useVatType(entity.vatType)

    return (
        <Stack horizontal={false} verticalAlign="center" tokens={{ childrenGap: 's2 s1', padding: 's2 0' }} wrap>
            <Text>{entity.description}</Text>
            <Stack horizontal tokens={{ childrenGap: 's2' }}>
                <FormattedDateBadge date={entity.date} />
                <Badge size="medium" appearance="tint">
                    {vatTypeName}
                </Badge>
            </Stack>
        </Stack>
    )
}
